export default __webpack_public_path__ + "static/media/avatar_pyper4.4080a38c.mp3";